import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const updateDeliveryRequest = (id, storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/delivery', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};



export const DeliveryReturnRequest = (storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/delivery-return-store',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
